/*
 * @Author: lijh(¯﹃¯*)
 * @Date: 2023-12-12 09:55:58
 * @LastEditors: lijh(¯﹃¯*)
 * @LastEditTime: 2024-03-06 09:53:03
 * @Description: description
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import ElementUI from "element-ui";
import App from "./App";
import router from "./router";
// import 'element-ui/lib/theme-chalk/index.css';
import "../static/icon/iconfont.css";
import cookie from "./utils/cookie";
import store from "./vuex/store";
import moment from "moment";
// 全局注册组件
import YlCascader from "./components/custom/YlCascader.vue";
import YlScrollBar from "./components/custom/YlScrollBar.vue";
import VsDialog from "./components/custom/VsDialog.vue";
import CommonDialog from "./components/custom/CommonDialog.vue";
import CommonButton from "./components/custom/CommonButton.vue";
import Preview from "./components/common/Preview.vue";
import DialogPreview from "./components/common/DialogPreview.vue";
import HistoricalAttachment from "./components/common/HistoricalAttachment.vue";
import htmlToPdf from "./utils/htmlToPdf";
import NewDataForm from "./components/common/NewDataForm.vue";
import MemberQueryForm from "./components/common/MemberQueryForm.vue";
import { tipsMixin } from "./pages/mixins/tipsMixin";

import VueTinymce from "@packy-tang/vue-tinymce";
//el-dialog自定义拖拽指令 可变大小
import "./utils/directive/dialogDrag";
Vue.use(VueTinymce);
Vue.use(htmlToPdf);

Vue.prototype.moment = moment;

Vue.mixin(tipsMixin);

Vue.filter("dateFormat", function(dateStr, pattern = "YYYY-MM-DD") {
  return dateStr ? moment(dateStr).format(pattern) : "";
});
Vue.filter("MonthFormat", function(MonthStr, pattern = "YYYY-MM") {
  return MonthStr ? moment(MonthStr).format(pattern) : "";
});
Vue.filter("YearFormat", function(MonthStr, pattern = "YYYY") {
  return MonthStr ? moment(MonthStr).format(pattern) : "";
});
Vue.filter("datetimeFormat", function(
  dateStr,
  pattern = "YYYY-MM-DD  HH:mm:ss"
) {
  return dateStr ? moment(dateStr).format(pattern) : "";
});

Vue.filter("filterContext", item => {
  return item ? item.replace(/<[^>]+>/g, "").replace(/&nbsp;/g, " ") : "";
});

Vue.use(ElementUI);

Vue.component("yl-cascader", YlCascader);
Vue.component("yl-scrollbar", YlScrollBar);
Vue.component("vs-dialog", VsDialog);
Vue.component("common-dialog", CommonDialog);
Vue.component("common-button", CommonButton);
Vue.component("Preview", Preview);
Vue.component("DialogPreview", DialogPreview);
Vue.component("HistoricalAttachment", HistoricalAttachment);
Vue.component("NewDataForm", NewDataForm);
Vue.component("MemberQueryForm", MemberQueryForm);

Vue.config.productionTip = false;

let token = cookie.getCookie("token");
router.beforeEach((to, from, next) => {
  if (to.path == "/") {
    next({ path: "/login" });
  } else {
    next();
  }
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store: store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js